import { inject, Injectable } from '@angular/core';
import { SharedApiService } from '../../../../shared/service/util.service';

@Injectable({
  providedIn: 'root'
})
export class MembershipService {

  private endpoint1 = `Portal/Membership/ApplyForMembership`
  private endpoint2 = `Portal/Membership/ApplyCoupon`
  private endpoint3 = `Portal/Membership/UpdateMembership`
  private endpoint4 = `Portal/Membership/AddAttachment`
  private endpoint5 = `Portal/Membership/GetMemberships`
  private endpoint6 = `Portal/TrainingLevel/GetLookup`
  private endpoint7 = `Portal/Membership/GetMembershipById`
  private endpoint8 = 'Portal/Membership/ReapplyForMembership'
  private endpoint9 = 'Portal/Membership/RemoveCoupon'

  private SharedApiService = inject(SharedApiService)

  ApplyForMembership(params: any) {
    return this.SharedApiService.PostToJsonOrFormWithToken(this.endpoint1, params)
  }

  ApplyCoupon(params: any) {
    return this.SharedApiService.PostToJsonOrFormWithToken(this.endpoint2, params)
  }

  AddAttachment(params: any) {
    return this.SharedApiService.PatchToJsonOrFormWithToken(this.endpoint4, params)
  }

  UpdateMembership(params: any) {
    return this.SharedApiService.UpdateToJsonOrFormWithToken(this.endpoint3, params)
  }

  getMembershipByUserId(id: number | string) {
    return this.SharedApiService.getAll2(this.endpoint5 + '?UserId=' + id);
  }

  getTraningLevelId() {
    return this.SharedApiService.getAll2(this.endpoint6);
  }

  getMemberShipById(id: number | string) {
    return this.SharedApiService.getById2(this.endpoint7, id);
  }

  reapplyOnMembership(params: any) {
    return this.SharedApiService.PostToJsonOrFormWithToken(this.endpoint8, params)
  }

  removeCoupon(params: any) {
    return this.SharedApiService.PostToJsonOrFormWithToken(this.endpoint9, params)
  }
}
